import { Component, OnInit, Input, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { SocialAuthService } from '@abacritt/angularx-social-login';
import { FacebookLoginProvider } from '@abacritt/angularx-social-login';
import { SocialUser } from '@abacritt/angularx-social-login';
import { LoaderServices } from '../../services/loader.service';
import { UserApiService } from '../../services/user-api.service';
import { AuthService } from '../../services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import firebase from 'firebase/compat/app';
import { FirebaseCloudFunctionsService } from '../../services/firebase-cloud-functions.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SubscriptionService } from '../../services/subscription.service';
import { AnalyticsUtils } from 'src/app/shared/services/analytics-utils';
import { FirebaseRemoteConfigService } from '../../services/firebase-remote-config.service';
import { UserOnboardingServeComponent } from '../user-onboarding-serve/user-onboarding-serve.component';
import { ReferrerTrackingService } from '../../services/referrer-tracking.service';
import { ReturnUrlService } from '../../services/return-url.service';

@Component({
    selector: 'app-facebook-login',
    templateUrl: './facebook-login.component.html',
    styleUrls: ['./facebook-login.component.scss'],
    standalone: false
})
export class FacebookLoginComponent implements OnInit {
   user!: SocialUser;
   loggedIn!: boolean;
   public redirectURL: any;
   public showButton: boolean = false;
   @Input() click = '';
   @Input() tapEvent = '';
   @Input() completedEvent = '';
   @Input() failEvent = '';

   constructor(
      private authService: SocialAuthService,
      private loader: LoaderServices,
      public userApiService: UserApiService,
      private auth: AuthService,
      private router: Router,
      public authFire: AngularFireAuth,
      private firebaseConfigService: FirebaseRemoteConfigService,
      private subscriptionService: SubscriptionService,
      private analyticsUtils: AnalyticsUtils,
      private modalService: NgbModal,
      private referrerTrackingService: ReferrerTrackingService,
      private returnUrlService: ReturnUrlService,
      @Inject(PLATFORM_ID) private platformId: Object
   ) {}

   async ngOnInit() {
      this.returnUrlService.captureReturnUrl();
      if (isPlatformBrowser(this.platformId)) {
         this.redirectURL = localStorage.getItem('redirectUrl');
      }
      const config = await this.firebaseConfigService.getConfigDefault();
      this.showButton = !!config?.show_fb_login;
      this.authService.authState.subscribe((user) => {
         // localStorage.setItem('authtoken', user.authToken)
         this.user = user;
         this.loggedIn = user != null;
      });
   }

   async signInWithFB() {
      this.analyticsUtils.SOCIAL_AUTH_BTN_TAP(this.tapEvent);
      this.authService
         .signIn(FacebookLoginProvider.PROVIDER_ID)

         // this.authFire.signInWithPopup( new firebase.auth.FacebookAuthProvider())
         .then(async (user: SocialUser) => {
            //   console.log(user);
            let accessToken = user.authToken;

            this.loader.show();
            
            const req = {
               token: accessToken
            };
            let response: any = await this.userApiService.facebookLogin(req);
            if (response.status) {
               let token = response.data;
               let isNew = response.is_new;
               this.referrerTrackingService.clearReferrerData();
               await this.auth.setToken(token);
               const userData: any =
                  await this.userApiService.fetchUserDetailsAndSave();

               await this.subscriptionService.setUserSubscriptionInfo();
               const subInfo = SubscriptionService.subscriptionData.getValue();
               if (subInfo.role === 'FREEMIUM') {
                  if (isNew){
                     this.analyticsUtils.SignupFlow_SaveUser_Completed('facebook');
                     // this.modalService.open(UserOnboardingServeComponent, {
                     //    centered: true,
                     //    scrollable: true,
                     //    size: 'xl',
                     //    modalDialogClass: 'paywall-popup-modal',
                     // });
                  } else this.subscriptionService.openPaywallModal();
               }

               this.auth.setLoggedIn();
               this.analyticsUtils.SOCIAL_AUTH_COMPLETED(
                  this.completedEvent,
                  userData.email,
                  response.is_new,
                  AnalyticsUtils.METHOD_FACEBOOK
               );

               // Check return_url first, then fall back to redirectURL from localStorage
               const returnUrl = this.returnUrlService.getReturnUrl();
               if (returnUrl) {
                  this.returnUrlService.redirectAfterAuth('/', token);
                  this.loader.hide();
                  return;
               }
                if (this.redirectURL) {
                   this.router.navigateByUrl(this.redirectURL).then();
                   this.loader.hide();
                   return;
                }
                this.router.navigateByUrl('/').then();

               this.loader.hide();
            } else {
               this.loader.hide();
               this.analyticsUtils.SOCIAL_AUTH_FAILED(
                  this.failEvent,
                  '',
                  response.message,
                  null
               );
            }
         });
   }

   signOut(): void {
      this.authService.signOut();
   }
}
